import CoachesInfo from './CoachesInfo'

export default CoachesInfo
